import * as React from 'react';
import type { SVGProps } from 'react';

const SvgXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#222426"
      d="M.252.252a.857.857 0 0 1 1.213 0L6 4.788 10.535.252a.858.858 0 0 1 1.214 1.213L7.212 6l4.537 4.535a.858.858 0 1 1-1.214 1.214L6 7.212l-4.535 4.537a.857.857 0 1 1-1.213-1.214L4.788 6 .252 1.465a.857.857 0 0 1 0-1.213Z"
    />
  </svg>
);
export default SvgXIcon;
